module.exports = __webpack_public_path__ + "img/welcome-circles.f37c3c4a.png";